export const DataHooks = {
  Root: 'MyWalletApp.Root',
  EmptyState: 'MyWalletApp.EmptyState',
  ErrorText: 'MyWalletApp.ErrorText',
  ErrorCtaButton: 'MyWalletApp.ErrorCtaButton',
} as const;
